<template lang="">
	<div class="responsive-note">
    <div>
      <v-btn
        class="pa-5 my-11 b"
        height="50px"
        outlined
        @click="openModalProduct">
        <img class="pr-3" src="../../../../static/images/add-circle-black.svg"/>Adicionar produto
      </v-btn>
    </div>

    <!-- Filtragem de itens pelo status -->
		<ProductFilter />

    <!-- Tabela  -->
		<v-card>
			<v-data-table
        :headers="headers"
        :items="items.data"
        :range="7"
        class="elevation-2 fs-20"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @page-count="pageCount = $event"
        >
        <template v-slot:item.product_updated_at="{item}">
          {{format(item.product_updated_at)}}
        </template>
        <template v-slot:item.product_is_active="{item}">
          <status-toggle
            :item="item"
            :item-status="item.product_is_active"
            item-type="product"
            :updateAction="updateProduct"
            :disableAction="disableProduct"
          >
          </status-toggle>
        </template>
        <template v-slot:item.actions="{item}">
          <button class="b-4 buttonCopyEdit ma-2"
            @click="setProduct(item)"
          >
            <img src="../../../../static/images/edit.svg"/>
          </button>
        </template>
        <template v-slot:no-data>
          <span>Registro não encontrado</span>
        </template>
			</v-data-table>
		</v-card>

    <!-- Pagination  -->
    <v-card class="mt-8">
			<div
				v-if="!loading"
				class="list-footer">
				<span></span>
				<v-pagination
          v-model="page"
          :length="pageCount"
          color="#F0F1F3"
          :total-visible="7"
        ></v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
						Ir para página
					</span>
					<label>
						<input
							v-model="goToPage"
							type="text"
						>
						<button
							@click="goToPageRequest"
							:disabled="disabledGoTo"
						>
							<div
								class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span
							:class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'"
							class="goToPage--helptext"
						>
							A página deve estar entre 1 e {{pageCount}}
						</span>
					</label>
				</div>
			</div>
		</v-card>

    <!-- Adding new product -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="620"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <ProductForm v-on:close="drawer = false"/>
    </v-navigation-drawer>

    <div style="height: 5px"></div>

	</div>
</template>
<script>
// Component
import ProductFilter from '@/components/Contents/AutomaticsTriggers/ProductFilter.vue'
import StatusToggle from '@/components/StatusToggle.vue'
import ProductForm from '@/components/Contents/AutomaticsTriggers/ProductForm.vue'

// token
import VueCookies from 'vue-cookies'

// Lib
import { mapActions, mapMutations, mapState } from 'vuex'

//mixins
import date from '../../../mixins/date'
import toaster from '@/mixins/toaster.js'

export default {
	name: 'Table',
  mixins: [date, toaster],
	components: {
		ProductFilter,
		StatusToggle,
    ProductForm
	},
  data () {
		return {
			goToPage: 1,
      showGoToPageHelpText: false,
      disabledGoTo: false,
      perPage: 30,
      drawer: false,
      new_product: '',
      status: null,
      posts: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      statusToggle: false
		}
  },
	async created () {
    // this.statusToggle = this.itemStatus
    const token = VueCookies.get('jwt-login')
    this.setLoading(true)
    try {
      this.setFilter(null)
      this.setPageSize(100)
      await this.getProducts({token: token})
      this.setLoading(false)
    } catch (error) {
      this.toaster(
        'Erro na requisição',
        "warning",
        true
      );
    }
  },
  computed: {
    ...mapState('Product', {
      items: 'items',
      loading: 'loading',
      loadingClear: 'loadingClear',
      size: 'size',
      pagination: 'pagination'
    }),
    headers () {
      return [
        { value: '', text: '', class: 'header-table grey lighten-2' },
        { value: 'product_name', text: 'Produto', class: 'header-table grey lighten-2' },
        { value: 'product_owner_name', text: 'Owner', class: 'header-table grey lighten-2' },
        { value: 'product_updated_at', text: 'Atualizado em', sortable: true, class: 'header-table grey lighten-2' },
        { value: 'product_is_active', text: 'Status', class: 'header-table grey lighten-2' },
        { value: 'actions', text: '', class:"grey lighten-2" }
      ]
    },
  },
  methods: {
    ...mapActions('Product', [
      'getProducts',
      'updateProduct',
      'disableProduct'
    ]),
    ...mapMutations('Product', {
      setProductToEdit: 'SET_PRODUCT_TO_EDIT',
      setLoading: 'SET_LOADING',
      setLoadingClear: 'SET_LOADING_CLEAR',
      setPage: 'SET_PAGE',
      setPageSize: 'SET_PAGE_SIZE',
      setFilter: 'SET_FILTER',
      setCurrentPage: 'SET_CURRENT_PAGE',
      unsetProductToEdit: 'UNSET_PRODUCT_TO_EDIT',
    }),
		async goToPageRequest () {
      this.page = +this.goToPage
    },
    setProduct (itemRow) {
      this.drawer = !this.drawer
      this.setProductToEdit(itemRow)
    },
    openModalProduct () {
      this.drawer = true
      this.unsetProductToEdit()
    }
  },
	watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.pageCount) {
        this.showGoToPageHelpText = true
        this.disabledGoTo = true
      } else {
        this.showGoToPageHelpText = false
        this.disabledGoTo = false
      }
    },
  }
}
</script>
<style lang="scss" scoped>

table.v-table thead tr th {
  font-size: 20px!important;
}

th, td {
  padding-left: 48px
}

// .fs-20 {
// 	font-size: 20px !important;
// }

.v-btn {
  min-width: 50px
}

.v-pagination__item--active {
  box-shadow: none !important;
  background: #a4a4af !important;
}

.v-pagination__navigation, .v-pagination__item {
  border: none !important;
  box-shadow: none !important;
}

.list-footer {
	background: var(--white);
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2.625rem;
  margin: 80px 0 10px 0px;
	height: 64px;
}

.goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }

  // PAgination
	.iconStyle {
		width: 20px;
		height: 20px;
		background: transparent
	}

  .vs__actions {
    padding-right: 20px
  }

  .inputCopy {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
    width: 492px; 
    height: 48px;
    padding: 15px;
    background: transparent;
    font-family: var(--dm-sans-regular);
    color: var(--grey);
  }
  
  // Responsivo para o note 
  .responsive-note {
    width: 1224px
  }
  @media screen and (max-width: 1377px) {
    .responsive-note {
      width: 819px
    }
  }


  .list-pagination {
    display: flex;
    align-items: center;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 4px;
    cursor: pointer;

    a {
      padding: 23px;
    }
  }

  .list-pagination--item {
    font-family: var(--dm-sans-regular);
    font-size: 0.875rem;
  }

  .active {
    // background: var(--grey-day-020);
    border-radius: 4px;
  }

  .disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: var(--grey-day-030);
  }

  i.icon.icon-prev-page,
  i.icon.icon-next-page {
    font-size: 12px;
  }
}

.v-pagination__navigation, .v-pagination__item {
  border: none;
  box-shadow: none !important;
}
    
// Edit button
.buttonCopyEdit {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

// Button add new product
.b {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/Product.vue